import {
  Box,
  Header,
  SpaceBetween,
  Cards,
  Link,
  ColumnLayout,
  Pagination,
  CollectionPreferences,
  CollectionPreferencesProps,
  Table,
  Button,
  Modal,
} from '@cloudscape-design/components';

import { DashboardViewLayout } from '../../components/DashboardViewLayout';
import { useNavigate } from '@tanstack/react-router';
import { useUrlFilterState, useUrlRangeState } from '../../common/filtering/filters';
import { ListTable } from '../../components/dashboard/ListTable';
import { useState } from 'react';
import { CreateListModal } from '../../components/CreateListModal';
import { unhideLists } from '../../common/api/lists';
import { hideLists } from '../../common/api/lists';
import { PlaceList } from '../../common/types';

export default function View() {
  const navigate = useNavigate();
  const { query, setQuery } = useUrlFilterState();
  // relative times are in the past vs future
  const past = true;
  const { range, setRange } = useUrlRangeState(past);
  const [now, setNow] = useState(new Date());

  const [createOpen, setCreateOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState<PlaceList[]>([]);
  const resourceName = 'Lists';

  const showingHidden = query.tokens.filter((token) => token.propertyKey === 'hidden').length !== 0;

  return (
    <DashboardViewLayout breadcrumbs={[{ text: resourceName, href: '' }]} contentType="table">
      <ListTable
        now={now}
        setNow={setNow}
        query={query}
        setQuery={setQuery}
        range={range}
        setRange={setRange}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        additionalActions={
          <SpaceBetween size="xs" direction="horizontal">
            <Button
              variant="primary"
              onClick={() => {
                setCreateOpen(true);
              }}
            >
              Create
            </Button>
            {showingHidden ? (
              <Button
                variant="normal"
                iconName="undo"
                onClick={async () => {
                  await unhideLists(selectedItems.map((item) => item.uuid));
                  setQuery({
                    operation: query.operation,
                    tokens: query.tokens.filter((token) => token.propertyKey !== 'hidden'),
                  });
                  setSelectedItems([]);
                  setNow(new Date(new Date().getTime() + 1000));
                }}
                disabled={selectedItems.length === 0}
              >
                Unhide
              </Button>
            ) : (
              <Button
                variant="normal"
                iconName="remove"
                onClick={async () => {
                  await hideLists(selectedItems.map((item) => item.uuid));
                  setSelectedItems([]);
                  setNow(new Date(new Date().getTime() + 1000));
                }}
                disabled={selectedItems.length === 0}
              >
                Hide
              </Button>
            )}
          </SpaceBetween>
        }
      />
      <CreateListModal
        open={createOpen}
        setOpen={setCreateOpen}
        onComplete={(data) => {
          setSelectedItems([]);
          setNow(new Date(new Date(data.created_at + 'Z').getTime() + 1000));
        }}
      />
    </DashboardViewLayout>
  );
}
